import { houseRulesQueryKeys as e } from "./useHouseRulesQueryKeys.mjs";
import { useQuery as t } from "@maat/store-hooks";
import { houseRulesApi as n } from "@maat/api-main";
//#region src/houseRules/useHouseRulesQuery.ts
var r = () => t({
	queryKey: e.list(),
	queryFn: () => n.getHouseRules()
});
//#endregion
export { r as useHouseRulesQuery };
